import React, { useState } from 'react';
import Tada from 'react-reveal/Tada';

const Cart = (props) => {

  const counter = props.items.reduce((a, b) => a + (b['amount'] || 0), 0)

  return <Tada spy={counter}>
    <a href='/kosarica' id='cart_icon'>
      <div className="back_circle"></div>
      <div className="num_items_container">
        <span>{counter}</span>
      </div>
      <img src={require('../images/cart.svg')} alt="košarica" />
    </a>
  </Tada>

}

export default Cart



// WEBPACK FOOTER //
// app/frontend/components/Cart.jsx